import { createContext, useContext } from "react";
import type React from "react";
import invariant from "tiny-invariant";

import type {
  VideoClipPipPosition,
  VideoClipPipShape,
  VideoClipPipSize,
} from "./hooks/useVideoClipSettingsStore";

export interface VideoClipContextValue {
  cameraPreviewRef: React.RefObject<HTMLVideoElement | null>;
  isCameraEnabled: boolean;
  isScreenSharing: boolean;
  pipPosition: VideoClipPipPosition;
  pipShape: VideoClipPipShape;
  pipSize: VideoClipPipSize;
  videoRef: React.RefObject<HTMLVideoElement | null>;
}

const VideoClipContext = createContext<VideoClipContextValue | null>(null);
VideoClipContext.displayName = "VideoClipContext";

export const VideoClipContextProvider = VideoClipContext.Provider;

export const useVideoClipContext = (): VideoClipContextValue => {
  const ctx = useContext(VideoClipContext);
  invariant(
    ctx,
    "useVideoClipContext must be used within VideoClipContextProvider",
  );
  return ctx;
};
